// pages
import Home from 'components/pages/Home/Home';

function App() {
	return <Home />;
}

export default App;
